import {RouteDefinition} from '../../../routes';
import {ServerSettingsScreen} from './ServerSettingsScreen';

export const ServerSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/server',
        component: ServerSettingsScreen,
    },
];
